module.exports = __webpack_public_path__ + "static/media/getting-support-large@2x.94ab7c63.png";